// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__BZ7rs","point":"Summary_point__13mEv","score":"Summary_score__nkl2x","badge":"Summary_badge__a1HxL"};